import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory, useLocation} from 'react-router-dom'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import {Box} from '@mui/material'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import {useSnackbar} from 'notistack'

import {ReactComponent as MailSent} from '@progyny/assets/images/mail-sent.svg'
import SubmitButton from '@progyny/components/Buttons/SubmitButton'
import SimpleMessageContainer from '@progyny/components/SimpleMessageContainer'
import {useRequestUserEmailConfirmationMutation} from '@progyny/generated/graphql'
import {useMeStore} from '@progyny/store/meStore'

interface ConfirmEmailProps {}

const ConfirmEmail: FC<ConfirmEmailProps> = () => {
  const user = useMeStore((s) => s.user)
  const history = useHistory()
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar()
  const {state} = useLocation() as {state: {email: string}}
  const emailAddress = state?.email || user?.email

  const [confirmMutation, {loading}] = useRequestUserEmailConfirmationMutation({
    variables: {email: emailAddress!},
  })

  const handleResendLink = async () => {
    try {
      await confirmMutation()
    } catch (e) {}

    enqueueSnackbar({
      message: t('confirm_email_email_is_sent'),
      variant: 'success',
    })
  }

  const handleGoHome = async () => {
    history.goBack()
  }

  return (
    <SimpleMessageContainer
      image={MailSent}
      actionArea={[
        <Button
          key={'previous-button'}
          variant={'text'}
          startIcon={<ArrowBackIcon />}
          onClick={handleGoHome}
        >
          {t('confirm_email_previous')}
        </Button>,
        <SubmitButton
          key={'submit-button'}
          onClick={handleResendLink}
          loading={loading}
        >
          {t('confirm_email_resend_email')}
        </SubmitButton>,
      ]}
      message={
        <Box maxWidth={420}>
          <Typography variant={'h1'} textAlign={'center'} gutterBottom>
            {t('confirm_email_email_sent')}
          </Typography>
          <Typography variant='body2' textAlign={'center'}>
            {t('confirm_email_we_emailed', {email: emailAddress})}
          </Typography>
          <Typography variant='body2' textAlign={'center'}>
            {t('confirm_email_if_no_email_arrives_please')}
          </Typography>
        </Box>
      }
    />
  )
}

export default ConfirmEmail
